module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_web_002.0406215e.png";